import { Injectable } from '@angular/core';
import { SettingsService } from '../settings.service';
import { Response } from '@angular/http';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Roteiro } from '../comum/modelos/roteiro';
import { RoteiroPontoFisico } from '../comum/modelos/roteiro-ponto-fisico';
import { AgendaRoteiroPontoFisico } from '../comum/modelos/agenda-roteiro-ponto-fisico';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { VisaoRoteirosAtivos } from '../comum/modelos/visao-roteiros-ativos';
import { AgendaRoteiroSetor } from '../comum/modelos/agenda-roteiro-setor';
import { AgendaRoteiroProcesso } from '../comum/modelos/agenda-roteiro-processo';
import { AgendaRoteiroRotina } from '../comum/modelos/agenda-roteiro-rotina';

@Injectable()
export class RoteiroService {

  private _host: string;

  constructor(
    private _settingsService: SettingsService,
    private _http: HttpClient) {
    this._host = this._settingsService.obterHostBase() + '/roteiros/';
  }

  obterRoteirosClienteHttp(id: number): Observable<Roteiro[]> {
    return this._http.get(this._host + 'cliente/' + id)
      .catch(this.handleError);
  }

  obterRoteirosUsuarioHttp(id: number): Observable<Roteiro[]> {
    return this._http.get(this._host + 'usuario/' + id)
      .catch(this.handleError);
  }

  obterRoteiroHttp(id: number): Observable<Roteiro> {
    return this._http.get(this._host + id)
      .catch(this.handleError);
  }

  obterPontosFisicosRoteiroHttp(id: number): Observable<RoteiroPontoFisico[]> {
    return this._http.get(this._host + 'ponto-fisico-cadastro/' + id)
      .catch(this.handleError);
  }

  cadastrarRoteiroHttp(roteiro: Roteiro): Observable<HttpResponse<Roteiro>> {
    return this._http
      .post(this._host, roteiro, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  atualizarRoteiroHttp(roteiro: Roteiro): Observable<HttpResponse<Roteiro>> {
    return this._http
      .put(this._host, roteiro, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  apagarRoteiroHttp(id: number): Observable<HttpResponse<Roteiro>> {
    return this._http
      .delete(this._host + id, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  cadastrarPontosFisicosRoteiroHttp(pontosFisicosRoteiro: RoteiroPontoFisico[]): Observable<HttpResponse<RoteiroPontoFisico[]>> {
    return this._http
      .post(this._host + 'ponto-fisico/', pontosFisicosRoteiro, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerPontosFisicosRoteiroHttp(pontosFisicosRoteiro: RoteiroPontoFisico[]): Observable<HttpResponse<RoteiroPontoFisico[]>> {
    return this._http
      .patch(this._host + 'ponto-fisico/', pontosFisicosRoteiro, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  cadastrarAgendasPontosFisicosRoteiroHttp(agendasPontosFisicosRoteiro: AgendaRoteiroPontoFisico[]):
    Observable<HttpResponse<AgendaRoteiroPontoFisico[]>> {
    return this._http
      .post(this._host + 'agenda-ponto-fisico/', agendasPontosFisicosRoteiro, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerAgendasPontosFisicosRoteiroHttp(agendasPontosFisicosRoteiro: AgendaRoteiroPontoFisico[]):
    Observable<HttpResponse<AgendaRoteiroPontoFisico[]>> {
    return this._http
      .patch(this._host + 'agenda-ponto-fisico/', agendasPontosFisicosRoteiro, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterVisoesRoteirosAtivosHttp(id: number): Observable<VisaoRoteirosAtivos[]> {
    return this._http.get(this._host + 'visao-roteiros-ativos/' + id)
      .catch(this.handleError);
  }

  obterAgendasRoteiroPontoFisicoHttp(id: number): Observable<AgendaRoteiroPontoFisico[]> {
    return this._http.get(this._host + 'agenda-roteiro-ponto-fisico/' + id)
      .catch(this.handleError);
  }

  obterAgendaRoteiroPontoFisicoHttp(id: number): Observable<AgendaRoteiroPontoFisico> {
    return this._http.get(this._host + 'agenda-ponto-fisico/' + id)
      .catch(this.handleError);
  }

  obterAgendasRoteiroSetorHttp(id: number): Observable<AgendaRoteiroSetor[]> {
    return this._http.get(this._host + 'setor/' + id)
      .catch(this.handleError);
  }

  cadastrarAgendasRoteiroSetorHttp(agendas: AgendaRoteiroSetor[]): Observable<HttpResponse<AgendaRoteiroSetor[]>> {
    return this._http
      .post(this._host + 'setor/', agendas, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerAgendasRoteiroSetorHttp(agendas: AgendaRoteiroSetor[]): Observable<HttpResponse<AgendaRoteiroSetor[]>> {
    return this._http
      .patch(this._host + 'setor/', agendas, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterAgendasRoteiroProcessoHttp(id: number): Observable<AgendaRoteiroProcesso[]> {
    return this._http.get(this._host + 'processo/' + id)
      .catch(this.handleError);
  }

  cadastrarAgendasRoteiroProcessoHttp(agendas: AgendaRoteiroProcesso[]): Observable<HttpResponse<AgendaRoteiroProcesso[]>> {
    return this._http
      .post(this._host + 'processo/', agendas, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerAgendasRoteiroProcessoHttp(agendas: AgendaRoteiroProcesso[]): Observable<HttpResponse<AgendaRoteiroProcesso[]>> {
    return this._http
      .patch(this._host + 'processo/', agendas, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  obterAgendasRoteiroRotinaHttp(id: number): Observable<AgendaRoteiroRotina[]> {
    return this._http.get(this._host + 'rotina/' + id)
      .catch(this.handleError);
  }

  cadastrarAgendasRoteiroRotinaHttp(agendas: AgendaRoteiroRotina[]): Observable<HttpResponse<AgendaRoteiroRotina[]>> {
    return this._http
      .post(this._host + 'rotina/', agendas, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  removerAgendasRoteiroRotinaHttp(agendas: AgendaRoteiroRotina[]): Observable<HttpResponse<AgendaRoteiroRotina[]>> {
    return this._http
      .patch(this._host + 'rotina/', agendas, {
        observe: 'response'
      })
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/roteiro.service.ts